import { useRef, useState } from 'react';
import SiteLink from 'components/shared/sitelink/sitelink';
import useIsMobile from 'hooks/utils/useIsMobile';
import useSliderMomentum from 'hooks/utils/useSliderMomentum';
import ArrowRight from 'components/shared/arrow-right';
import ArrowLeft from 'components/shared/arrow-left';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import styles from './articleSlider.module.scss';
import Image from '../../shared/image';

const ArticleSlider = ({ data, locale }) => {
  const { title, blogArticles, anchorId } = data;

  const [carouselPositioning, setCarouselPositioning] = useState({
    atLeftSide: true,
    atRightSide: blogArticles.length <= 4, // initially, it will be true only if all the items are showing in the first/only slide
  });

  const isMobile = useIsMobile();
  const carouselRef = useRef();
  const router = useRouter();
  useSliderMomentum(carouselRef);
  const updateCarouselPositioning = () => {
    setCarouselPositioning({
      atLeftSide: carouselRef.current?.scrollLeft === 0,
      atRightSide:
        carouselRef.current?.scrollLeft + window?.innerWidth >= carouselRef.current?.scrollWidth,
    });
  };

  const carouselItemWidth = 500;
  let timeout;

  return (
    <section id={anchorId} className={styles.articleSliderSection} key={title}>
      <h2 className={styles.title}>{title}</h2>
      <div
        className={styles.carouselWrapper}
        ref={carouselRef}
        onScroll={() => {
          clearTimeout(timeout);
          timeout = setTimeout(() => updateCarouselPositioning(carouselRef), 200);
        }}
      >
        <div className={styles.carousel}>
          {!isMobile && blogArticles?.length > 0 && (
            <>
              {!carouselPositioning.atRightSide && (
                <button
                  type="button"
                  className={styles.nextButton}
                  onClick={() => {
                    carouselRef.current.scrollBy(carouselItemWidth, 0);
                    updateCarouselPositioning();
                  }}
                >
                  <ArrowRight />
                </button>
              )}
              {!carouselPositioning.atLeftSide && (
                <button
                  type="button"
                  className={styles.previousButton}
                  onClick={() => {
                    carouselRef.current.scrollBy(-carouselItemWidth, 0);
                    updateCarouselPositioning();
                  }}
                >
                  <ArrowLeft />
                </button>
              )}
            </>
          )}
          {blogArticles?.length &&
            blogArticles.map(article => (
              <Article articleData={article} locale={locale} router={router} />
            ))}
        </div>
      </div>
    </section>
  );
};

const Article = ({ locale, articleData, router }) => {
  const { articleLink, headlineImage, articleType } = articleData;

  return (
    <div className={styles.articleWrapper}>
      <SiteLink locale={locale} href={addLocaleToHref(articleLink?.slug, locale, router)}>
        <div className={styles.articleHeadlineImageMedium}>
          <Image
            src={headlineImage.image}
            layout="fill"
            loading="eager"
            priority
            sizes="(max-width: 899px) 50vw, 25vw"
          />
        </div>
        <h3 className={styles.categoryType}>{articleType}</h3>
        <h4 className={styles.articleTitle}>{articleLink?.title}</h4>
      </SiteLink>
    </div>
  );
};

export default ArticleSlider;
